import { useToast } from '../components/toast/CollapsedToastContainer';

// Objet toast qui imite l'API de react-toastify
export const toast = {
  success: (message, options = {}) => {
    if (typeof window !== 'undefined' && window.__TOAST_CONTEXT__) {
      return window.__TOAST_CONTEXT__.addToast(message, 'success', options);
    }
  },
  error: (message, options = {}) => {
    if (typeof window !== 'undefined' && window.__TOAST_CONTEXT__) {
      return window.__TOAST_CONTEXT__.addToast(message, 'error', options);
    }
  },
  info: (message, options = {}) => {
    if (typeof window !== 'undefined' && window.__TOAST_CONTEXT__) {
      return window.__TOAST_CONTEXT__.addToast(message, 'info', options);
    }
  },
  warning: (message, options = {}) => {
    if (typeof window !== 'undefined' && window.__TOAST_CONTEXT__) {
      return window.__TOAST_CONTEXT__.addToast(message, 'warning', options);
    }
  },
  dismiss: (id) => {
    if (typeof window !== 'undefined' && window.__TOAST_CONTEXT__) {
      if (id) {
        window.__TOAST_CONTEXT__.removeToast(id);
      } else {
        window.__TOAST_CONTEXT__.removeAllToasts();
      }
    }
  }
};

// Hook pour utiliser le toast dans les composants
export const useCustomToast = () => {
  const context = useToast();
  
  // Mettre à jour le contexte global
  if (context && typeof window !== 'undefined') {
    window.__TOAST_CONTEXT__ = context;
  }
  
  return {
    success: (message, options) => context.addToast(message, 'success', options),
    error: (message, options) => context.addToast(message, 'error', options),
    info: (message, options) => context.addToast(message, 'info', options),
    warning: (message, options) => context.addToast(message, 'warning', options),
    dismiss: (id) => {
      if (id) {
        context.removeToast(id);
      } else {
        context.removeAllToasts();
      }
    }
  };
};